import React from 'react';
import LegalLandingPage from './LegalLandingPage';
import { TERMS_AND_CONDITIONS } from './legalContent';

const TermsAndConditions: React.FC = () => (
  <LegalLandingPage
    doc={TERMS_AND_CONDITIONS}
    footerLinks={[
      { to: '/privacy-policy', label: 'Privacy Policy' },
      { to: '/cookies-policy', label: 'Cookies Policy' },
    ]}
  />
);

export default TermsAndConditions;
